import { useMemo } from 'react';
import clsx from 'clsx';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { NOTE_ACTIONS, AppointmentNote } from './Types';
import { convertToStoreLocalTime } from '@/common/utils/time';
import { PinIcon } from '@/common/icons/PinIcon';
import { DDDownIcon } from '@/common/icons/DDDownIcon';
import { PinIconSet } from '@/common/icons/PinIconSet';
import { DDUpIcon } from '@/common/icons/DDUpIcon';
//import { RightChevron } from '@/common/icons/RightChevron';
//import AppointmentModalWrapper from '@/views/Pages/Appointments/ScheduleAppointmentModal/AppointmentModalWrapper';

const useStyles: any = makeStyles(() => ({
  container: {
    color: 'grey',
    border: '1px solid #E0E0E0',
    padding: '16px 12px',
    marginBottom: 12,
    borderRadius: 8
  },
  saveDetails: {
    color: '#666',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1
  },
  title: {
    color: '#000'
  },
  noteProperties: {
    marginTop: 12,
    padding: '8px 12px',
    backgroundColor: '#F5F5F5',
    borderRadius: 8,
    fontSize: 12
  },
  controlContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    paddingRight: 10
  },
  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    '& > span': {
      cursor: 'pointer'
    },
    '& > span:first-child': {
      cursor: 'pointer',
      marginRight: 54
    }
  },
  pinLoading: {
    '& span': {
      color: '#000',
      width: '20px !important',
      height: '20px !important'
    }
  },
  content: {
    fontWeight: 400,
    margin: '8px 16px 0 0 ',
    color: '#000',
    overflow: 'hidden'
  },
  collapsed: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(70vw - 200px)'
  },
  apptHeading: {
    fontSize: 12,
    fontWeight: 501,
    lineHeight: 1.5
  },
  apptServiceName: {
    fontSize: 14,
    fontWeight: 501,
    lineHeight: 1.5,
    color: '#000'
  },
  apptStatus: {
    fontSize: 14,
    fontWeight: 501,
    lineHeight: 1.5,
    color: '#000'
  },
  appointmentDeets: {
    marginTop: 12,
    padding: '12px 12px 8px 12px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#F5F5F5',
    borderRadius: 8
  },
  appointmentProps: {
    maxHeight: 76
  },
  editAppointmentBtn: {
    width: 40,
    height: 76,
    margin: 0,
    padding: 30,
    cursor: 'pointer'
  },
  expandCollapse: {},
  pin: {}
}));

export interface NoteItemProps {
  note: AppointmentNote;
  actionCallback: (
    note: AppointmentNote,
    action: keyof typeof NOTE_ACTIONS,
    data?: any
  ) => void;
}

export const AppointmentNoteItem = (props: NoteItemProps) => {
  const { note, actionCallback } = props;
  const classes = useStyles();

  /*const [showEditAppointment, setShowEditAppointment] = useState<boolean>(
    false
  );*/

  const saveDetails = useMemo(
    () =>
      `${convertToStoreLocalTime(
        note.createdAt,
        'MM/DD/yyyy'
      )} at ${convertToStoreLocalTime(note.createdAt, 'h:mm A')}`,
    [note]
  );

  return (
    <Grid container className={classes.container}>
      <Grid xs={8} item>
        <div className={classes.saveDetails}>{saveDetails}</div>
        <div className={classes.title}>Appointment</div>
        <div
          className={clsx([
            classes.content,
            note.expanded ? '' : classes.collapsed
          ])}
        >
          {note.content}
        </div>
      </Grid>
      <Grid xs={4} item className={classes.controlContainer}>
        <Grid container className={classes.controls}>
          {note.pinLoading && (
            <span className={classes.pinLoading}>
              <CircularProgress />
            </span>
          )}
          {!note.pinLoading && (
            <span
              className={classes.pin}
              onClick={() =>
                actionCallback(
                  note,
                  note.isPinned
                    ? NOTE_ACTIONS.UNPIN_NOTE
                    : NOTE_ACTIONS.PIN_NOTE
                )
              }
            >
              {note.isPinned ? <PinIconSet /> : <PinIcon />}
            </span>
          )}
          <span
            className={classes.expandCollapse}
            onClick={() =>
              actionCallback(
                note,
                note.expanded
                  ? NOTE_ACTIONS.COLLAPSE_NOTE_VIEW
                  : NOTE_ACTIONS.EXPAND_NOTE_VIEW
              )
            }
          >
            {note.expanded ? (
              <DDUpIcon stroke="#000" />
            ) : (
              <DDDownIcon stroke="#000" />
            )}
          </span>
        </Grid>
      </Grid>
      {note.expanded && (
        <Grid container className={classes.appointmentDeets}>
          <Grid xs={11} item className={classes.appointmentProps}>
            <Typography className={classes.apptServiceName}>
              {note?.service?.description} at {note.store.description}
            </Typography>
            <Typography className={classes.apptHeading}>
              {`${convertToStoreLocalTime(
                note.start,
                'dddd, MMMM D'
              )} at ${convertToStoreLocalTime(note.start, 'h:mmA')}`}
            </Typography>
            <Typography className={classes.apptStatus}>
              {note?.isConfirmed && 'Confirmed'}&nbsp;
              {note?.isCancelled && 'Cancelled'}
            </Typography>
          </Grid>
          <Grid xs={1} item>
            {/*<div
              className={classes.editAppointmentBtn}
              onClick={() => setShowEditAppointment(true)}
            >
              <RightChevron />
            </div>*/}
          </Grid>
        </Grid>
      )}
      {/*<AppointmentModalWrapper
        appointmentId={
          note?.id // note id for an appt note is that of the appt
        }
        note={note}
        actionCallback={actionCallback}
        showModal={showEditAppointment}
        setShowModal={setShowEditAppointment}
      />*/}
    </Grid>
  );
};
